import { Box, Flex, Button, Text } from '@chakra-ui/react'
import { GrCamera } from 'react-icons/gr'

export function CameraView({ videoRef, canvasRef, onCaptureImage }) {
  return (
    <Box bgColor="#313E44" height="calc(100vh - 100px)">
      <Flex height="90%" position="relative">
        <video
          ref={videoRef}
          playsInline
          autoPlay
          muted
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
          }}
        />
        <canvas ref={canvasRef} style={{ display: 'none' }} />
      </Flex>
      <Flex justify={'center'} alignItems={'center'} direction={'column'} mt={5} position="absolute" bottom="20px" width="100%">
        <Button
          bgColor="#37F091"
          padding={8}
          paddingTop={14}
          paddingBottom={14}
          borderRadius={'full'}
          onClick={onCaptureImage}
          _hover={{
            bgColor: '#2cce7a',
          }}
        >
          <GrCamera color="#313E44" size={45} />
        </Button>
        <Text marginTop={3} fontSize="lg" fontWeight={'medium'} color="white">
          Capturar Foto
        </Text>
      </Flex>
    </Box>
  )
}
